import { Component } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {


  constructor(private storageService: StorageService){}

  ngOnInit(){
    this.storageService.clearrAllValue();
  }
}
